import { createFileRoute } from '@tanstack/react-router'
import { AttemptPage } from '_/features/exams/ui/pages/attempt-page'

const AttemptRoute = () => {
	const { examid } = Route.useParams()
	return <AttemptPage examId={examid} />
}

export const Route = createFileRoute('/_authenticated/exams/$examid')({
	staticData: { title: 'examsim_attempt_title' },
	component: AttemptRoute,
})
